import { render, staticRenderFns } from "./Accisure.vue?vue&type=template&id=687c056a"
import script from "./Accisure.vue?vue&type=script&lang=js"
export * from "./Accisure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports